function readMore() {
    document.addEventListener('click', function (e) {
        const target = e.target.closest('.read_more') || e.target.closest('.read_less');

        if (target) {
            e.preventDefault();
            if (target.classList.contains('read_more')) {
                target.classList = 'read_less';
                console.log(document);
                if (document.documentElement.getAttribute('lang') == 'de') {
                    target.innerHTML = 'Text einklappen';
                } else {
                    target.innerHTML = 'Read less...';
                }
                target.parentElement.insertAdjacentHTML(
                    'afterend',
                    localStorage.getItem(
                        'data-readmore-id-' + _getParent(target, 'content-text').getAttribute('data-readmore-id')
                    )
                );
            } else if (target.classList.contains('read_less')) {
                target.classList = 'read_more';
                if (document.documentElement.getAttribute('lang') == 'de') {
                    target.innerHTML = 'Mehr erfahren...';
                } else {
                    target.innerHTML = 'Read more...';
                }

                let currentEl = target.parentElement.nextElementSibling;
                let nextEl = currentEl.nextElementSibling;
                do {
                    if (!currentEl) currentEl = nextEl;
                    nextEl = currentEl.nextElementSibling;
                    currentEl.remove();
                    currentEl = undefined;
                } while (!nextEl.classList.contains('end_of_read'));
            }
        }
    });
    const reads = document.querySelectorAll('.read_more');
    if (reads.length == 0) return;

    reads.forEach((el, index) => {
        let text = '';
        let currentEl;
        let nextEl;
        currentEl = el.parentElement?.nextElementSibling;

        _getParent(el, 'content-text').setAttribute('data-readmore-id', index);
        do {
            if (!currentEl) currentEl = nextEl;

            nextEl = currentEl.nextElementSibling;

            currentEl.remove();
            text += currentEl.outerHTML;
            currentEl = undefined;
        } while (!nextEl.classList.contains('end_of_read'));
        nextEl.innerHTML = '';
        text += nextEl.outerHTML;
        // nextEl.remove();

        localStorage.setItem('data-readmore-id-' + index, text);
    });
}

function _getParent(el, parentSelector) {
    if (parentSelector === undefined) {
        parentSelector = document;
    }
    var parents = [];
    var p = el.parentNode;
    while (!p.classList.contains(parentSelector)) {
        var o = p;
        parents.push(o);
        p = o.parentNode;
    }
    parents.push(p);
    return parents[parents.length - 1];
}

document.addEventListener('DOMContentLoaded', () => {
    readMore();
});
